const importDixa = (messengerToken, onReady, onChatOpen, callbackFn) => {
	if (window._dixa_) {
		callbackFn();
	} else {
		window._dixa_ = {
			invoke: (m, a) => {
				window._dixa_.pendingCalls = window._dixa_.pendingCalls || [];
				window._dixa_.pendingCalls.push([m, a]);
			},
			addListener: (event, listener) => {
				window._dixa_.pendingAddListenerCalls = window._dixa_.pendingAddListenerCalls || [];
				window._dixa_.pendingAddListenerCalls.push([event, listener]);
			}
		};

		const script = window.document.createElement('script');
		script.onload = () => {
			window._dixa_.invoke('init', {
				messengerToken,
				hideToggler: true,
				showWidgetCloseButton: true,
				fullscreenOffsets: { top: 'var(--regulationHeight)' }
			});
			onReady();
			callbackFn();

			window._dixa_.addListener('on-widget-open-changed', isChatOpen => {
				onChatOpen(isChatOpen);
			});
		};
		script.type = 'text/javascript';
		script.setAttribute('charset', 'utf-8');
		script.async = true;
		script.src = 'https://messenger.dixa.io/bootstrap.js';

		document.getElementsByTagName('head')[0].appendChild(script);
	}
};

const updateDixaUser = userData => {
	window._dixa_.invoke('setUserIdentity', { email: userData.email, name: userData.name, type: 'claim' });
};

const clearDixaUser = () => {
	window._dixa_.invoke('purgeUserIdentity');
};

const openDixaChat = bool => {
	window._dixa_.invoke('setWidgetOpen', bool);
};

export { importDixa, updateDixaUser, clearDixaUser, openDixaChat };
